import { IPreloadedState } from 'shared/types/redux';

export const selectSearchMeta = (state: IPreloadedState) => state.searchMeta;
